import { Notification } from 'element-ui';

export default {
  methods: {
    showNotification(errorContext) {
      Notification({
        title: 'Warning',
        message: `${errorContext}`,
        type: 'warning',
        duration: 0,
      });
    },
    errorHandlerMixin(error) {
      if (typeof error !== 'undefined'
        && typeof error.response !== 'undefined'
        && typeof error.response.data !== 'undefined'
        && typeof error.response.data.errors !== 'undefined'
        && Array.isArray(error.response.data.errors)
      ) {
        const errorItem = error.response.data.errors[0];
        const errorTitle = errorItem.title ? String(errorItem.title).replace(/_+/g, ' ') : '';
        const fileError = (typeof errorItem.links !== 'undefined' && typeof errorItem.links.about !== 'undefined')
          ? String(errorItem.links.about).replace(/\\+/g, '')
          : '';
        const errorDetail = errorItem.detail || '';
        const errorStatus = errorItem.status || '';

        const errorContext = `${errorStatus} ${errorTitle} ${fileError} ${errorDetail}`;

        this.showNotification(errorContext);
        return false;
      }

      this.showNotification(error);
      return false;
    },
  },
};
